"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
exports.__esModule = true;
var React = require("react");
var react_1 = require("react");
var styled_components_1 = require("styled-components");
var SituationSelectOption_1 = require("./SituationSelectOption");
var MAX_VISIBLE_OPTIONS_COUNT = 3;
var RECOMMENDED_GROUP_NAME = "よく選択されているイベント";
// 選択項目コンポーネント
exports.SituationSelectOptionsGroup = function (props) {
    var _a = react_1.useState(false), touchingShowAll = _a[0], setTouchingShowAll = _a[1];
    var _b = react_1.useState(false), hasShownAll = _b[0], setHasShownAll = _b[1];
    var selectOption = function (index) {
        props.onSelect(props.optionsGroup.options[index]);
    };
    var showAll = function () {
        setHasShownAll(true);
    };
    var onTouchStartShowAll = function () {
        setTouchingShowAll(true);
    };
    var onTouchEndShowAll = function () {
        setTouchingShowAll(false);
    };
    var elements = [];
    props.optionsGroup.options.forEach(function (option, index) {
        if (hasShownAll || index < MAX_VISIBLE_OPTIONS_COUNT) {
            elements.push(React.createElement(SituationSelectOption_1.SituationSelectOption, { key: option.id, option: option, selected: props.selected, onSelect: props.onSelect }));
        }
        else if (index === MAX_VISIBLE_OPTIONS_COUNT) {
            elements.push(React.createElement(OptionsGroupShowAll, { key: option.id, touching: touchingShowAll, onClick: showAll, onTouchStart: onTouchStartShowAll, onTouchEnd: onTouchEndShowAll }, "+\u3082\u3063\u3068\u898B\u308B"));
        }
    });
    return (React.createElement(OptionsGroup, { key: props.optionsGroup.name },
        React.createElement(OptionsGroupName, { isRecommended: props.optionsGroup.is_recommended }, props.optionsGroup.is_recommended
            ? RECOMMENDED_GROUP_NAME
            : props.optionsGroup.name),
        elements));
};
var OptionsGroupShowAll = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 30px;\n  margin: 0px 20px;\n  line-height: 30px;\n  text-align: center;\n  font-size: 14px;\n  color: #777;\n  ", "\n"], ["\n  height: 30px;\n  margin: 0px 20px;\n  line-height: 30px;\n  text-align: center;\n  font-size: 14px;\n  color: #777;\n  ",
    "\n"])), function (props) {
    return props.touching
        ? "\n        background-color: #ccc;\n        color: #777;\n      "
        : "";
});
var OptionsGroup = styled_components_1["default"].div(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
var OptionsGroupName = styled_components_1["default"].div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  height: 30px;\n  margin: 15px 20px 10px 20px;\n  font-weight: bold;\n  font-size: 16px;\n  line-height: 30px;\n  color: ", ";\n"], ["\n  height: 30px;\n  margin: 15px 20px 10px 20px;\n  font-weight: bold;\n  font-size: 16px;\n  line-height: 30px;\n  color: ", ";\n"])), function (props) { return (props.isRecommended ? "#ff7a14" : "black"); });
var templateObject_1, templateObject_2, templateObject_3;
